import { render, staticRenderFns } from "./store-card-product.vue?vue&type=template&id=317d5822&"
import script from "./store-card-product.vue?vue&type=script&lang=js&"
export * from "./store-card-product.vue?vue&type=script&lang=js&"
import style0 from "./store-card-product.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('317d5822')) {
      api.createRecord('317d5822', component.options)
    } else {
      api.reload('317d5822', component.options)
    }
    module.hot.accept("./store-card-product.vue?vue&type=template&id=317d5822&", function () {
      api.rerender('317d5822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/delivery-selector/store-card-product.vue"
export default component.exports